export const environment = {
  production: true,
  buildId: '4033065333324431',
  configFile: 'config.json',
};
